<div style="width:50vw; min-width: 400px;">
    <forge-toolbar>
        <h2 slot="start" class="forge-typography--heading4">{{dialogTitle}}</h2>
        <div slot="end" class="forge-typography--heading2">{{dialogSubtitle}}</div>
    </forge-toolbar>

    <mat-dialog-content>
        <forge-inline-message style="margin-bottom: 4px;">{{message}}</forge-inline-message>

        <drag-and-drop-group-list [displayProperty]="display" [groupBy]="groupProperty" [input]="groups[0]"
                                  [output]="splitGroups" [sequenceProperty]="sequenceProperty">
        </drag-and-drop-group-list>
    </mat-dialog-content>

    <div fxLayout="row" fxLayoutAlign="end center">
        <mat-dialog-actions class="actions">
            <forge-button variant="outlined" (click)="close()">Cancel</forge-button>
            <forge-button variant="raised" (click)="add()">Save</forge-button>
        </mat-dialog-actions>
    </div>
</div>